import { AppState } from '../';

const settingState = (state: AppState) => state.settings.setting;
const settingsState = (state: AppState) => state.settings.settings;
const globalServiceSettingState = (state: AppState) => state.settings.globalServiceSetting;

export const settingsSelectors = {
  settingState,
  settingsState,
  globalServiceSettingState,
};
